/** An API error carrying the HTTP status and, when present, the server's reason
 * and whether the action is merely gated on step-up (re-authentication). */
export class ApiError extends Error {
    status;
    reason;
    requiresStepUp;
    constructor(status, message, reason, requiresStepUp = false) {
        super(message);
        this.status = status;
        this.reason = reason;
        this.requiresStepUp = requiresStepUp;
        this.name = 'ApiError';
    }
}
/** Build an ApiError from a non-ok Response, parsing the JSON body
 * `{ error, stepUp }` when the server provides one (403s from the auth engine). */
export async function errorFrom(res, path) {
    let reason;
    let stepUp = false;
    try {
        const body = (await res.json());
        if (typeof body.error === 'string') {
            reason = body.error;
        }
        if (typeof body.stepUp === 'boolean') {
            stepUp = body.stepUp;
        }
    }
    catch {
        /* empty or non-JSON body — fall back to a generic message */
    }
    return new ApiError(res.status, reason ?? `request to ${path} failed: ${res.status}`, reason, stepUp);
}
function authHeaders(opts) {
    return opts.token ? { Authorization: `Bearer ${opts.token}` } : {};
}
async function getJson(opts, path, auth) {
    const f = opts.fetchImpl ?? fetch;
    const res = await f(new URL(path, opts.baseUrl), {
        headers: auth ? authHeaders(opts) : {},
    });
    if (!res.ok) {
        throw await errorFrom(res, path);
    }
    return (await res.json());
}
/** Liveness check (unauthenticated). */
export function getHealth(opts) {
    return getJson(opts, '/health', false);
}
/** Gateway status (mode, schema version, outbox counts, audit count). */
export function getStatus(opts) {
    return getJson(opts, '/status', true);
}
/** Recent captured-message metadata (redaction-safe; no payloads). */
export function getRecentMessages(opts, limit = 20) {
    const clamped = Math.max(1, Math.min(100, Math.trunc(limit)));
    return getJson(opts, `/messages/recent?limit=${clamped}`, true);
}
// Control-plane (fleet management) client.
export * from './control-plane';
// Identity (auth/session/MFA/membership) client.
export * from './auth';
// Platform (super-admin) client (P6).
export * from './platform';
//# sourceMappingURL=index.js.map